import { render } from "./login-form.vue?vue&type=template&id=5bcbdffc&scoped=true"
import script from "./login-form.vue?vue&type=script&lang=js"
export * from "./login-form.vue?vue&type=script&lang=js"

import "./login-form.vue?vue&type=style&index=0&id=5bcbdffc&scoped=true&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcbdffc"]])

export default __exports__